import { Outlet } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Header />
      <main className="flex-1 pt-16 md:pt-[72px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}